import { UseCase } from '@/domain/core/UseCase'
import { UserGeometry } from '@/domain/models/UserGeometry/UserGeometry'
import { Result } from '@/domain/protocols/Result'

import type { IUserGeometryRepository } from '@/data/UserGeometryRepository/IUserGeometryRepository'

// Soft-delete (tombstone): the repository marks deleted + unsynced and emits UserGeometryChanged.
export class DeleteUserGeometryUseCase implements UseCase<UserGeometry, Promise<Result<void>>> {
  constructor(private readonly repository: IUserGeometryRepository) {}

  async execute(geometry: UserGeometry): Promise<Result<void>> {
    try {
      return await this.repository.deleteGeometry(geometry)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
